import React from 'react';
import Helmet from 'react-helmet';

export const TitleComponent = ({ title }) => {
    var defaultTitle = 'PTerodactyl';
    return (
        <Helmet>
            <title>{title ? title : defaultTitle}</title>
        </Helmet>
    );
};

